import { PresenceFeeClubFilters } from '@/interfaces/filters/presenceClubTeamFilters';
import { PresenceFeeTeamFilters } from '@/interfaces/filters/presenceFeeTeamFilters';
import { PresenceFilters } from '@/interfaces/filters/presenceFilters';
import { Presence } from '@/interfaces/presence';
import { EntityResource } from './entity.resource';
import { PresenceFilterVariables } from './queryVariables/filters/presence.filters';

/**
 * Resource list obecności
 *
 * @export
 * @class PresenceResource
 * @extends {EntityResource<Presence>}
 */
export class PresenceResource extends EntityResource<Presence> {
  protected getFields = {
    id: true,
    date: true,
    hour: true,
    minute: true,
    scheduleContainer: {
      id: true,
      name: true
    },
    presentPlayers: {
      id: true
    },
    description: true
  };

  protected listFields = {
    id: true,
    date: true,
    hour: true,
    minute: true,
    scheduleContainer: {
      id: true,
      name: true
    }
  };

  protected listVariables = PresenceFilterVariables;

  constructor() {
    super({ entityName: 'presence' });
  }

  /**
   * Pobiera liste płac klubu
   *
   * @param {PresenceFeeClubFilters} filters
   * @returns
   * @memberof PresenceResource
   */
  public feeClubList(filters: PresenceFeeClubFilters) {
    this.listQueryName = 'presenceFeeClubList';
    this.listVariables.filters = 'PresenceFeeClubFilters';
    return super.list(filters);
  }

  /**
   * Pobiera liste płac grupy treningowej
   *
   * @param {PresenceFeeTeamFilters} filters
   * @returns
   * @memberof PresenceResource
   */
  public feeTeamList(filters: PresenceFeeTeamFilters) {
    this.listQueryName = 'presenceFeeTeamList';
    this.listVariables.filters = 'PresenceFeeTeamFilters';
    return super.list(filters);
  }

  /**
   * Pobiera listę obecności grupy treningowej
   *
   * @param {PresenceFilters} filters
   * @returns
   * @memberof PresenceResource
   */
  public list(filters: PresenceFilters) {
    this.listQueryName = 'presenceList';
    this.listVariables.filters = 'PresenceFilters';

    return super.list(filters);
  }
}

export const presenceResource = new PresenceResource();
